import React from 'react';

import { TouchableOpacity, Image, Text } from "react-native";

const CommentsIndicator = (props) => {

    const { onPress, numberOfComments } = props;
    const isDisabled = onPress === undefined ? true : false;

    return (
        <TouchableOpacity
            style={{ alignItems: 'center', flexDirection: 'row' }}
            onPress={() => {
                if (onPress) onPress();
            }}
            disabled={isDisabled}
        >
            <Image
                source={require('../../../img/icons/comment/CommentIcon.png')}
                style={{ width: 15, height: 15, marginRight: 6, tintColor: 'white' }}
                resizeMode={'contain'}
            />

            <Text style={{ fontSize: 14, color: 'white' }}>
                { numberOfComments }
            </Text>

        </TouchableOpacity>
    )

}

export default CommentsIndicator;
